var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXcross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2545_796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.58908 4.99976L9.87783 0.711013C9.95373 0.632428 9.99573 0.527178 9.99478 0.417929C9.99383 0.30868 9.95001 0.204175 9.87275 0.126922C9.7955 0.0496683 9.69099 0.0058479 9.58175 0.00489856C9.4725 0.00394922 9.36725 0.0459469 9.28866 0.121846L4.99991 4.4106L0.711161 0.121846C0.632577 0.0459469 0.527326 0.00394922 0.418077 0.00489856C0.308829 0.0058479 0.204323 0.0496683 0.12707 0.126922C0.0498166 0.204175 0.00599618 0.30868 0.00504684 0.417929C0.0040975 0.527178 0.0460952 0.632428 0.121994 0.711013L4.41074 4.99976L0.121994 9.28851C0.0438814 9.36665 0 9.47261 0 9.5831C0 9.69358 0.0438814 9.79954 0.121994 9.87768C0.200131 9.95579 0.306093 9.99967 0.416578 9.99967C0.527063 9.99967 0.633025 9.95579 0.711161 9.87768L4.99991 5.58893L9.28866 9.87768C9.3668 9.95579 9.47276 9.99967 9.58324 9.99967C9.69373 9.99967 9.79969 9.95579 9.87783 9.87768C9.95594 9.79954 9.99982 9.69358 9.99982 9.5831C9.99982 9.47261 9.95594 9.36665 9.87783 9.28851L5.58908 4.99976Z",
    fill: "#D9DAE0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2545_796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXcross);
export default __webpack_public_path__ + "static/media/xcross.70d1f44f3cb32a5b3985e362df173f95.svg";
export { ForwardRef as ReactComponent };